module.exports = __webpack_public_path__ + "static/media/rating-star-average-icon.330964dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/rating-star-average-icon.svg
// module id = 642
// module chunks = 0